import { render, staticRenderFns } from "./role-component.vue?vue&type=template&id=2353e1be&scoped=true"
import script from "./role-component.vue?vue&type=script&lang=js"
export * from "./role-component.vue?vue&type=script&lang=js"
import style0 from "./role-component.vue?vue&type=style&index=0&id=2353e1be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353e1be",
  null
  
)

export default component.exports